"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeContext = require("../contexts/ThemeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FormBuilderFeedback = props => {
  var {
    theme,
    validation,
    title,
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement(_ThemeContext.FormBuilderThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, {
    outsideGutter: false
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Spacer, {
    space: 5
  }), /*#__PURE__*/_react.default.createElement(_componentsWeb.Feedback, {
    validation: validation,
    variant: {
      icon: true
    },
    title: title
  }, children), /*#__PURE__*/_react.default.createElement(_componentsWeb.Spacer, {
    space: 5
  })))));
};
FormBuilderFeedback.propTypes = {
  theme: _propTypes.default.string,
  validation: _propTypes.default.string,
  title: _propTypes.default.string,
  children: _propTypes.default.node
};
FormBuilderFeedback.defaultProps = {
  theme: _ThemeContext.DEFAULT_THEME,
  validation: '',
  title: '',
  children: null
};
var _default = exports.default = FormBuilderFeedback;